import { NavLink } from "react-router-dom";
import { useState } from "react";

const Sidebar = ({ isNarrow, toggleSidebar }) => {
  return (
    <aside className={`sidebar ${isNarrow ? "narrow" : ""}`}>
      {/* Logo Section */}
      <div className="sidebar-header">
        <div className="sidebar-logo">
          {!isNarrow ? (
            <h1 className="logo-text">Quick Track</h1>
          ) : (
            <div className="logo-icon">Q</div>
          )}
        </div>
       
      </div>

      {/* Navigation Menu */}
      <nav className="sidebar-menu">
        <NavLink to="/dashboard" className={({ isActive }) => isActive ? "active" : ""}>
          <i className="bx bx-home"></i>
          <span>Dashboard</span>
        </NavLink>
        
        <NavLink to="/workspaces" className={({ isActive }) => isActive ? "active" : ""}>
          <i className="bx bx-briefcase"></i>
          <span>Workspace</span>
        </NavLink>
        
        <NavLink to="/members" className={({ isActive }) => isActive ? "active" : ""}>
          <i className="bx bx-user"></i>
          <span>Members</span>
        </NavLink>

        <NavLink to="/reports" className={({ isActive }) => isActive ? "active" : ""}>
          <i className="bx bx-bar-chart-alt"></i>
          <span>Reports</span>
        </NavLink>

        {/* <NavLink to="/activity" className={({ isActive }) => isActive ? "active" : ""}>
          <i className="bx bx-history"></i>
          <span>Activity</span>
        </NavLink> */}

        <NavLink to="/settings" className={({ isActive }) => isActive ? "active" : ""}>
          <i className="bx bx-cog"></i>
          <span>Settings</span>
        </NavLink>
      </nav>

      {/* Bottom Pattern Section */}
      <div className="sidebar-bottom">
        <div className="sidebar-pattern">
          <div className="pattern-line"></div>
          <div className="pattern-line"></div>
          <div className="pattern-line"></div>
          <div className="pattern-line"></div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;